import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import TanstackTable from "../../../Components/Table/TanstackTable";

const FleetDetails = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );
  const FleetDetailsApi = async (selectedFilter) => {
    try {
      const res = await axInst.post("pvin/fleet-details", selectedFilter);
      return res.data;
    } catch (error) {
      console.error("Error fetching fleet details:", error.response || error);
      throw error;
    }
  };

  const columns = useMemo(
    () => [
      { header: "LOB", accessorKey: "LOB" },
      { header: "PPL", accessorKey: "PPL" },
      { header: "PL", accessorKey: "PL" },
      { header: "Count", accessorKey: "Count" },
    ],
    []
  );

  return (
    <TanstackTable
      heading="Fleet Details"
      columns={columns}
      apiFn={FleetDetailsApi}
      queryKey="FleetDetails"
      filter={selectedFilter}
      theadColor="bg-[#1F4B70]"
      height="max-h-[250px]"
    />
  );
};

export default FleetDetails;
